import { Controller } from '@hotwired/stimulus'
import { organizationAWSEKSDashboardNodegroupNodesPath } from '~/routes'
import { getJSON } from '~/utils/get_json'

export default class extends Controller {
  static values = {
    organizationId: String,
  }

  async toggle(event) {
    event.preventDefault()

    const button = event.currentTarget
    const nodegroupId = button.dataset.awsEksNodegroupDrilldownNodegroupIdValue
    if (!nodegroupId) {
      return
    }

    const row = button.closest('tr')

    const existingDetailsRow = this.element.querySelector(
      `[data-aws-eks-nodegroup-drilldown-details="${CSS.escape(nodegroupId)}"]`,
    )
    if (existingDetailsRow) {
      existingDetailsRow.remove()
      return
    }

    this.removeExistingDetailsRow()

    const detailsRow = document.createElement('tr')
    detailsRow.dataset.awsEksNodegroupDrilldownDetails = nodegroupId

    const detailsCell = document.createElement('td')
    detailsCell.colSpan = row.cells.length
    detailsCell.className = 'p-0'

    const card = document.createElement('div')
    card.className = 'card mb-0'

    const cardBody = document.createElement('div')
    cardBody.className = 'card-body p-0'
    cardBody.appendChild(this.loadingHtml())

    card.appendChild(cardBody)
    detailsCell.appendChild(card)
    detailsRow.appendChild(detailsCell)

    row.insertAdjacentElement('afterend', detailsRow)

    try {
      const { request } = getJSON(organizationAWSEKSDashboardNodegroupNodesPath(this.organizationIdValue, nodegroupId))
      const nodes = await request
      const body = detailsRow.querySelector('.card-body')
      body.textContent = ''
      body.appendChild(this.renderNodeList(nodes))
    } catch (error) {
      const body = detailsRow.querySelector('.card-body')
      body.textContent = ''
      body.appendChild(this.renderError(error))
    }
  }

  removeExistingDetailsRow() {
    const existing = this.element.querySelector('[data-aws-eks-nodegroup-drilldown-details]')
    if (existing) {
      existing.remove()
    }
  }

  renderNodeList(nodes) {
    if (!Array.isArray(nodes) || nodes.length === 0) {
      const empty = document.createElement('div')
      empty.className = 'text-muted'
      empty.textContent = 'No nodes found.'
      return empty
    }

    const wrapper = document.createElement('div')
    wrapper.className = 'table-responsive'

    const table = document.createElement('table')
    table.className = 'table table-sm mb-0'

    const thead = document.createElement('thead')
    const headerRow = document.createElement('tr')
    const headerLabels = ['Node', 'AWS Instance ID', 'EC2 Instance']

    headerLabels.forEach((label) => {
      const th = document.createElement('th')
      th.textContent = label
      headerRow.appendChild(th)
    })

    thead.appendChild(headerRow)
    table.appendChild(thead)

    const tbody = document.createElement('tbody')

    nodes.forEach((node) => {
      const row = document.createElement('tr')

      const nameCell = document.createElement('td')
      nameCell.textContent = node.name || ''
      row.appendChild(nameCell)

      const idCell = document.createElement('td')
      idCell.textContent = node.aws_instance_id || ''
      row.appendChild(idCell)

      const instanceCell = document.createElement('td')
      if (node.ec2_instance) {
        const link = document.createElement('a')
        const url = node.ec2_instance.url
        if (url) {
          link.href = url
          link.addEventListener('click', (event) => {
            event.stopPropagation()
          })
        }
        link.className = 'link-primary'
        link.textContent = node.ec2_instance.label || node.ec2_instance.url || ''
        instanceCell.appendChild(link)
      } else if (node.aws_instance_id) {
        const span = document.createElement('span')
        span.className = 'text-muted'
        span.textContent = 'Unavailable'
        instanceCell.appendChild(span)
      } else {
        const span = document.createElement('span')
        span.className = 'text-muted'
        span.textContent = 'No instance'
        instanceCell.appendChild(span)
      }

      row.appendChild(instanceCell)
      tbody.appendChild(row)
    })

    table.appendChild(tbody)
    wrapper.appendChild(table)
    return wrapper
  }

  renderError(error) {
    console.error('[aws-eks-nodegroup-drilldown] failed to load nodes', error)
    const message = error?.message || 'Unable to load node details.'
    const container = document.createElement('div')
    container.className = 'text-danger'
    container.textContent = message
    return container
  }

  loadingHtml() {
    const loading = document.createElement('div')
    loading.className = 'text-muted'
    loading.textContent = 'Loading nodes...'
    return loading
  }
}
